<template>
  <div class="row">
    <MenuNavbar :taboption="taboption" />

    <TableBasic :payload="payload" />
  </div>
</template>

<script>
import TableBasic from "@/components/TableBasic.vue";
import MenuNavbar from "@/components/global/MenuNavbar.vue";
export default {
  components: {
    TableBasic,
    MenuNavbar,
  },
  data() {
    return {
      taboption: [
        {
          name: "Admin",
          component: "",
          payload: {},
        },
        {
          name: "Download",
          component: "",
          payload: {},
        },
        {
          name: "Finance",
          component: "",
          payload: {},
        },
        {
          name: "Editor",
          component: "",
          payload: {},
        },
        {
          name: "Store Manager",
          component: "",
          payload: {},
        },
      ],
      payload: {
        header: [
          {
            key: "user_id",
            label: "User ID",
            class: "text-center",
          },
          {
            key: "user_name",
            label: "User Name",
            class: "text-center",
          },
          {
            key: "role",
            label: "Role",
            class: "text-center",
          },
          {
            key: "created_date",
            label: "Created Date",
            class: "text-center",
          },
          {
            key: "actions",
            label: "Actions",
            class: "text-center",
          },
        ],
        value: [
          {
            user_id: "CWILAPA@PAXEL.CO",
            user_name: "CINDY WILAPA",
            role: "Admin",
            created_date: "01/01/2022",
            actions: "",
          },
        ],
        button_name: "Create New User",
        button_link: "/users/1",
        totalRows: 1,
        currentPage: 1,
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
      },
    };
  },
};
</script>

<style></style>
